import React from 'react';

interface DCModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export const DCModal: React.FC<DCModalProps> = ({
  isOpen,
  onClose,
  children,
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="matter-checklist-modal-overlay"
      onClick={handleOverlayClick}
    >
      <div className="matter-checklist-modal-content">{children}</div>
    </div>
  );
};
